<template>
  <el-dialog title="添加关键词" append-to-body :visible.sync="showModal" width="980px">
    <div class="keywords-layout-wrapper">
      <div class="keywords-table">
        <div class="title">
          <h3>关键词</h3>
        </div>
        <div class="filter-input">
          <el-select popper-class="el-select-custom-popper" :popper-append-to-body="false" v-model="filterType" style="width: 120px">
            <el-option v-for="item in filterTypes" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>

          <el-select
            v-if="filterType === 1"
            class="query-input"
            v-model="keywordQueryList"
            default-first-option
            :title="keywordQueryList.join(',')"
            :multiple-limit="10"
            popper-class="el-select-custom-popper"
            :popper-append-to-body="false"
            multiple
            filterable
            collapse-tags
            allow-create
            placeholder="请输入和您业务相关的关键词"
          >
            <el-option v-for="item in []" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>

          <el-cascader
            v-model="cascaderModel"
            v-if="filterType === 2"
            class="query-input"
            ref="industryCascader"
            popper-class="keywords-cascader-popper"
            @change="onSearchCategoryChange"
            :options="industryCategory"
            :props="cascaderProps"
            :show-all-levels="false"
            collapse-tags
            clearable
          ></el-cascader>

          <el-button class="query-btn" type="primary" @click="onSearchKeywordQuery">获取结果</el-button>
        </div>

        <el-table
          class="common-el-table-styles"
          v-loading="tableLoading"
          height="300"
          :data="keywordDataList.slice(0, loadedNum)"
          border
          style="width: 100%"
        >
          <el-table-column prop="keyword" label="关键词"> </el-table-column>
          <el-table-column prop="msv" label="月搜索（次）"> </el-table-column>

          <template v-if="mediaType === 2">
            <el-table-column prop="click_count" label="点击"> </el-table-column>
            <el-table-column prop="price" label="出价"> </el-table-column>
          </template>
          <el-table-column label="操作" width="90">
            <template slot-scope="{ row }">
              <el-button v-if="selectedKeywords.includes(row.keyword)" type="text" :disabled="true">已加</el-button>
              <el-button v-else type="text" @click="onSearchKeywordAdd(row)">添加</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="keywordDataList.length" class="bottom-text">
          <span>共{{ keywordDataList.length }}个结果，当前已加载{{ Math.min(loadedNum, keywordDataList.length) }}个</span>
          <div>
            <el-button v-if="loadedNum < keywordDataList.length" type="text" @click="loadMore" :loading="loadMoreLoading">
              加载更多
            </el-button>
            <el-button type="text" :loading="addLoading" @click="addLoadedItem">
              添加已加载的{{ Math.min(loadedNum, keywordDataList.length) }}个关键词
            </el-button>
          </div>
        </div>
      </div>
      <div class="keywords-results">
        <div class="title">
          <h3>已选（{{ resultList.length }}/1000）</h3>
          <div class="btns">
            <el-button type="text" @click="keywordsCollectModal = true">上传</el-button>&ensp;

            <el-select
              :value="empty"
              popper-class="el-select-custom-popper"
              class="el-select-dropdown"
              :popper-append-to-body="false"
              size="mini"
              @change="onResultAllCommand"
              style="width: 80px"
              placeholder="匹配方式"
            >
              <el-option v-for="item in paternList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
            <el-button type="text" @click="resultRemoveAll">清空</el-button>
          </div>
        </div>
        <div class="result-list" v-loading="addLoading">
          <div class="result-item bold">
            <span>关键词</span>
            <span>匹配方式</span>
          </div>

          <!-- element-ui 弹窗内select dropdown popper 定位问题，无奈设置zIndex，否则会有层级显示问题 -->
          <div
            class="result-item"
            :style="{ position: 'relative', zIndex: resultList.length - index }"
            v-for="(res, index) in resultList"
            :key="res.keyword + index"
          >
            <div class="res-text">
              <span class="index">{{ index + 1 }}</span>
              <span class="remove el-icon-error" @click="onResultItemRemove(index)"></span>
              <el-input class="res-input" v-model="res.keyword" placeholder="请输入或从左侧选择关键词">
                <span slot="suffix">{{ res.keyword.length }}/30</span>
              </el-input>
            </div>

            <el-select
              :value="res.patern.value"
              popper-class="el-select-custom-popper"
              :popper-append-to-body="false"
              class="el-select-dropdown"
              size="mini"
              @change="onResultItemChange($event, index)"
              style="width: 110px"
              placeholder="匹配方式"
            >
              <el-option v-for="item in paternList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer">
      <el-button @click="showModal = false">取 消</el-button>
      <el-button type="primary" @click="confirm">确 定</el-button>
    </div>

    <el-dialog :append-to-body="true" title="批量添加关键词" :visible.sync="keywordsCollectModal" width="400">
      <div>
        <p>每行一个标签（通过回车换行），支持黏贴多行文本添加标签词</p>
        <el-input v-model="keywordTextarea" rows="6" resize="none" type="textarea"></el-input>
        <p>{{ keywordTextareaList.length }}/1000</p>
      </div>
      <div slot="footer">
        <el-button @click="onKeywordsCollectCancel">取 消</el-button>
        <el-button type="primary" @click="onKeywordsCollectConfirm">确 定</el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>
<script>
// import industryCategory from '@/data/toutiao/ad_categroy.js'
import { getSearchKeywords } from '@/api/toutiao.model.js'
import { getSearchAdBidKeywordList } from '@/api/tencent.model.js'
import { SEARCH_MOBILE_UNION } from '@/views/create/gdt/model/siteset/siteset-const.js'
export default {
  // props: ['value', 'accountId', 'list'],
  props: {
    value: Boolean,
    accountId: [Number, String],
    list: Array,
    mediaType: {
      type: Number,
      default: 1 // 1 头条。 2 腾讯广告
    },
    paternList: {
      type: Array,
      default: () => [
        { label: '广泛', value: 'EXTENSIVE' },
        { label: '短语', value: 'PHRASE' },
        { label: '精确', value: 'PRECISION' }
      ]
    },
    filterTypes: {
      type: Array,
      default: () => [
        { label: '词根相关词', value: 1 },
        { label: '行业相关词', value: 2 }
      ]
    },
    siteSets: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      empty: '',
      loadMoreLoading: false,
      tableLoading: false,
      addLoading: false,
      keywordsCollectModal: false,
      // paternList: clone(paternList),
      keywordTextarea: '',
      cascaderModel: [],
      currIndex: 0,
      filterType: 1,
      // 表格数据
      keywordDataList: [],
      // 搜索关键词，最多10个
      keywordQueryList: [],
      // 已选结果
      resultList: [],
      cascaderProps: { multiple: true },
      industryCategory: []
    }
  },
  watch: {
    showModal(v) {
      if (v) {
        this.resultList = this.list || []
      }
    }
  },
  created() {
    fetch('/data/toutiao_industry.json')
      .then((res) => res.json())
      .then((res) => {
        this.industryCategory = res
      })
  },
  computed: {
    showModal: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    },
    loadedNum() {
      return (this.currIndex + 1) * 50
    },
    selectedKeywords() {
      return this.resultList.map((item) => item.keyword)
    },
    keywordTextareaList() {
      return this.keywordTextarea.split('\n').filter((word) => word.trim().length > 0)
    }
  },
  methods: {
    aaaaa() {},
    onSearchCategoryChange() {
      const nodes = this.$refs.industryCascader.getCheckedNodes(true)
      this.keywordQueryList = nodes.map((n) => n.label)
      this.onSearchKeywordQuery()
    },
    /**
     * @description: 按50条每次，模拟加载更多数据
     */
    loadMore() {
      this.loadMoreLoading = true
      this.tableLoading = true
      setTimeout(() => {
        this.currIndex = this.currIndex + 1
        this.tableLoading = false
        this.loadMoreLoading = false
      }, 400)
    },
    /**
     * @description: 把已加载的关键词添加到已选结果
     */
    async addLoadedItem() {
      this.addLoading = true
      await this.$nextTick()
      this.resultList = this.keywordDataList
        .slice(0, this.loadedNum)
        .map((res) => ({ ...res, patern: { ...this.paternList[0] } }))
        .concat(this.resultList)
        .slice(0, 1000)

      setTimeout(() => {
        this.addLoading = false
      }, 200)
    },
    /**
     * @description: 切换已选结果匹配方式
     * @param {*} cmd
     * @param {*} index
     */
    onResultItemChange(val, index) {
      const patern = this.paternList.find((item) => item.value === val)
      this.resultList.splice(index, 1, { ...this.resultList[index], patern })
    },

    /**
     * @description: 匹配方式全部修改
     */
    onResultAllCommand(cmd) {
      const patern = this.paternList.find((item) => item.value === cmd)
      this.resultList = this.resultList.map((item) => ({ ...item, patern }))
    },
    /**
     * @description: 添加单条关键词
     * @param {*} row
     */
    onSearchKeywordAdd(row) {
      const newList = this.resultList
      newList.unshift({ ...row, patern: { ...this.paternList[0] } })
      this.resultList = newList.slice(0, 1000)
    },
    /**
     * @description: 删除一项已选结果
     * @param {*} index
     */
    onResultItemRemove(index) {
      this.resultList.splice(index, 1)
    },
    resultRemoveAll() {
      this.resultList = []
    },
    confirm() {
      const uniqueObj = {}

      this.resultList.forEach((item) => {
        uniqueObj[item.keyword] = item
      })

      const resList = Object.values(uniqueObj)
      const len = this.resultList.length
      const resLen = resList.length

      if (resLen < len) {
        this.$Message.success(`已自动去重${len - resLen}个关键词`)
      }

      this.$emit('confirm', resList)
      this.showModal = false
      this.keywordQueryList = []
      this.cascaderModel = []
    },

    /**
     * @description: 把自定义关键词添加到已选结果
     */
    onKeywordsCollectConfirm() {
      const keywords = this.keywordTextareaList.map((word) => ({ keyword: word, patern: { ...this.paternList[0] } }))
      this.resultList = keywords.concat(this.resultList).slice(0, 1000)
      this.onKeywordsCollectCancel()
    },
    onKeywordsCollectCancel() {
      this.keywordsCollectModal = false
      this.keywordTextarea = ''
    },

    onSearchKeywordQuery() {
      if (this.tableLoading) return
      const query_list = this.keywordQueryList.slice(0, 10)
      if (this.keywordQueryList.length > 10) {
        const tmpModel = [...this.cascaderModel]
        this.cascaderModel = tmpModel.slice(0, 10)
        this.$Message.warning('最多添加10个关键词，已自动截取')
      }

      if (query_list.length === 0) return
      this.tableLoading = true
      ;(this.mediaType === 1
        ? getSearchKeywords({ ad_account_id: this.accountId, query_list })
        : getSearchAdBidKeywordList({
          ad_account_id: this.accountId,
          bidword: query_list.join(','),
          site_sets: this.siteSets.filter((i) => i !== SEARCH_MOBILE_UNION).join(','),
          recommend_category: 'RECOMMEND_BY_WORD'
          // page: 1,
          // page_size: 1000
        })
      )

        .then((data) => {
          if (this.mediaType === 2) {
            this.keywordDataList =
              data?.map((row) => {
                return {
                  keyword: row.word,
                  msv: row.month_query_count,
                  price: row.price,
                  click_count: row.click_count
                }
              }) || []
          } else {
            this.keywordDataList = data || []
          }
          // 每次搜索都把已加载的指针清零
          this.currIndex = 0

          this.tableLoading = false
        })
        .catch((e) => {
          this.tableLoading = false
        })
    }
  }
}
</script>
<style lang="scss">
.keywords-cascader-popper {
  .el-scrollbar__wrap {
    max-height: 240px; //修复样式问题
  }
}
</style>
<style lang="scss" scoped>
::v-deep .el-select-custom-popper {
  position: absolute !important;
  top: 30px !important;
  left: 0 !important;
}

.keywords-layout-wrapper {
  display: flex;
  > div {
    border-radius: 4px;
    border: 1px solid #eee;
    padding: 10px;
  }
  .title {
    position: relative;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    h3 {
      font-size: 15px;
    }
  }

  .keywords-table {
    flex: 1;
    .filter-input {
      display: flex;
      margin-bottom: 5px;

      .query-input {
        margin: 0 10px;
        flex: 1;
      }
    }
    .bottom-text {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 10px;
      font-size: 12px;
    }
  }

  ::v-deep .keywords-results {
    flex-basis: 360px;
    margin-left: 10px;
    .result-list {
      max-height: 368px;
      min-height: 300px;
      overflow: auto;
      padding-right: 4px;
      position: relative;
      z-index: 1;
      padding-bottom: 200px;
      .result-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 12px;
        cursor: pointer;
        &:hover {
          &.bold {
            background: transparent;
          }

          .res-text {
            .remove {
              display: block;
            }
            .index {
              visibility: hidden;
            }
            .el-input__suffix {
              visibility: visible !important;
            }
          }
        }
        &.bold {
          font-weight: 700;
        }
        .el-dropdown-link {
          cursor: pointer;
          font-size: 12px;
        }

        .res-text {
          display: flex;
          align-items: center;
          flex: 1;
          position: relative;

          .index {
            visibility: visible;
            white-space: nowrap;
          }

          .remove {
            display: none;
            font-size: 14px;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            z-index: 1;
          }

          .res-input {
            input {
              width: 95%;
              border: none;
              font-size: 12px;
              background: transparent;
            }
            .el-input__suffix {
              line-height: 32px;
              font-size: 12px;
              visibility: hidden;
            }
          }
        }
      }
    }
    .el-select-dropdown {
      border: none;
      box-shadow: none;
      .popper__arrow {
        display: none;
      }
      .el-input__inner {
        border: none;
        box-shadow: none;
        font-size: 12px;
        padding-left: 0;
        // 修改placeholder颜色
        &::placeholder {
          color: #1974ff;
        }
      }
    }
  }
}
</style>
